export enum Requiredness
{
    REQUIRED,
    OPTIONAL
}